import { ProductStatus } from 'generated/graphql';
import { required as requiredValidator, SelectInput, SelectInputProps } from 'react-admin';

export type ProductStatusInputProps = SelectInputProps;

const productStatuses = [
  { id: ProductStatus.WaitingForSubmission, name: 'WaitingForSubmission' },
  { id: ProductStatus.Processing, name: 'Processing' },
  { id: ProductStatus.Active, name: 'Active' },
];

export const ProductStatusInput: React.FC<ProductStatusInputProps> = ({
  choices = productStatuses,
  defaultValue = ProductStatus.Processing,
  validate = [requiredValidator()],
  ...restProps
}) => {
  return <SelectInput choices={choices} defaultValue={defaultValue} validate={validate} {...restProps} />;
};
